import * as React from "react";
import {
  Heading,
  Text,
  VStack
} from "@chakra-ui/react";

import {
  Contact,
  Information,
  Service
} from "./Layouts";


interface Props {
  nodes: any[]
  children?: React.ReactNode | undefined
  layout: string
  avatars?: any[] | undefined

  heading?: React.ReactNode | string | undefined
  headingWidth?: object | string | undefined
  description?: string | undefined
}


export const Flexbox: React.FC<Props> = ( props ) => {
  const nodeList: React.ReactNode[] = props.nodes.map( ( node: any, _index: number ) => {
    switch ( props.layout ) {
      case 'contact':
        return (
          <Contact
            key={ _index }
            node={ node }
            avatars={ props.avatars }
          />
        )
      case 'info':
        return (
          <Information
            key={ _index }
            node={ node.node }
          />
        )
      case 'service':
        return (
          <Service
            key={ _index }
            node={ node.node }
          />
        );
      default:
        return null;
    }
  });

  return (
    <VStack
      align="flex-start"
      spacing="80px"
    >
      { props.heading &&
        <VStack
          align="flex-start"
          spacing="24px"
          w={ props.headingWidth }
        >
          <Heading
            as="h2"
            fontSize="48px"
            fontWeight={ 700 }
            color="text.primary"
          >
            { props.heading }
          </Heading>
          { props.description &&
            <Text
              fontSize="16px"
              fontWeight={ 400 }
              color="text.secondary"
            >
              { props.description }
            </Text>
          }
        </VStack>
      }
      <VStack
        spacing="72px"
      >
        { nodeList }
      </VStack>
    </VStack>
  )
}
